import { Outlet } from "react-router-dom";
import AnnouncementBar from "@/components/layout/AnnouncementBar";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingWhatsApp from "@/components/whatsapp/FloatingWhatsApp";
import BackToTop from "@/components/common/BackToTop";
import CodeInjection from "@/components/common/CodeInjection";
import OrganisationStructuredData from "@/components/seo/OrganisationStructuredData";

export default function Layout() {
    return (
        <div className="flex min-h-screen flex-col bg-cs-offwhite">
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-cs-navy focus:text-white focus:px-4 focus:py-2 focus:font-mono focus:text-xs focus:uppercase focus:tracking-widest"
            >
                Skip to main content
            </a>
            <AnnouncementBar />
            <Header />
            <main id="main-content" className="flex-1" data-testid="main-content">
                <Outlet />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <BackToTop />
            {/* Mounted here rather than in App so the operator's analytics tags
                load on the public site only — keeping staff activity in /admin
                out of the client's analytics. Router keeps Layout mounted across
                public navigations, so the snippets are injected once. */}
            <CodeInjection />
            <OrganisationStructuredData />
        </div>
    );
}
